import { createFileRoute } from "@tanstack/react-router";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN, ROLE_USER } from "@/constants";

export const Route = createFileRoute("/_dashboard/participations")({
  beforeLoad: (args) => {
    const { context } = args;
    requireRole([ROLE_ADMIN, ROLE_USER])(args);
    return { isAdmin: context.session!.user!.isAdmin };
  },
});
